module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-pinterest-41426247715cfe651dd8c7af45b6fdaa.png";